"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertColHeaderConfigToRowData = void 0;
var convertColHeaderConfigToRowData = function (_a) {
    var colHeaderData = _a.colHeaderData, convertToRichText = _a.convertToRichText;
    return {
        id: "colHeader",
        isColHeader: true,
        cellData: colHeaderData.map(function (d, i) { return ({
            value: convertToRichText ? convertToRichText(d) : d, //draftjs data shape
            readOnly: true,
            id: "colHeaderCell_".concat(i),
        }); }),
    };
};
exports.convertColHeaderConfigToRowData = convertColHeaderConfigToRowData;
